import React, {Component} from 'react';
import styled from 'styled-components';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import {FormattedMessage, injectIntl, FormattedDate, FormattedTime} from 'react-intl';
import {connect} from 'react-redux';
import {PrimaryButton} from '../../common/Button';
import {InputFieldWithValidation} from '../../common/InputFieldWithValidation';
import RadioFields from '../../common/RadioFields';
import {
    domains,
    getInternalTicketFormStates,
    rootCauses,
} from '../../../constants/Utils';
import InputSelectFieldWithValidation from '../../common/InputSelectFieldWithValidation';
import buttonMessages from '../../../intl/common/buttonMessages';
import statusMessages from '../../../intl/common/formStatesMessages';
import exportConstantMessages from '../../../intl/common/exportMessages';
import DatePickerComponent from '../../common/datePicker/DatePickerComponent';
import moment from 'moment';
import PropTypes from 'prop-types';
import charsetMessages from '../../../intl/charsetMessages';
import {
    ASE_INTERNAL_TICKET_FORM,
    BUTTON_LABEL_DOWNLOAD,
    BUTTON_LABEL_EXPORT,
} from '../../../constants/formConstants';
import {
    ASE_EXPORT_INTERNAL_FORM_FIELD_CHARSET,
    ASE_EXPORT_INTERNAL_FORM_FIELD_DOCUMENTATION_UPDATE_NEEDED,
    ASE_EXPORT_INTERNAL_FORM_FIELD_ENGINE_TYPE,
    ASE_EXPORT_INTERNAL_FORM_FIELD_FROM,
    ASE_EXPORT_INTERNAL_FORM_FIELD_GEARBOX_TYPE,
    ASE_EXPORT_INTERNAL_FORM_FIELD_HAS_BEEN_ASSIGNED_TO,
    ASE_EXPORT_INTERNAL_FORM_FIELD_IS_ASSIGNED_TO,
    ASE_EXPORT_INTERNAL_FORM_FIELD_NOD_ID,
    ASE_EXPORT_INTERNAL_FORM_FIELD_DOCUMENT_ID,
    ASE_EXPORT_INTERNAL_FORM_FIELD_REQUEST_TYPE,
    ASE_EXPORT_INTERNAL_FORM_FIELD_ROOT_CAUSE,
    ASE_EXPORT_INTERNAL_FORM_FIELD_STATUS,
    ASE_EXPORT_INTERNAL_FORM_FIELD_TO,
    ASE_EXPORT_INTERNAL_FORM_FIELD_TYPE,
    ASE_EXPORT_INTERNAL_FORM_FIELD_VEHICLE_FAMILY,
    ASE_EXPORT_INTERNAL_FORM_LABEL_CHARSET,
    ASE_EXPORT_INTERNAL_FORM_LABEL_DOCUMENTATION_UPDATE_NEEDED,
    ASE_EXPORT_INTERNAL_FORM_LABEL_ENGINE_TYPE,
    ASE_EXPORT_INTERNAL_FORM_LABEL_FROM,
    ASE_EXPORT_INTERNAL_FORM_LABEL_GEARBOX_TYPE,
    ASE_EXPORT_INTERNAL_FORM_LABEL_HAS_BEEN_ASSIGNED_TO,
    ASE_EXPORT_INTERNAL_FORM_LABEL_IS_ASSIGNED_TO,
    ASE_EXPORT_INTERNAL_FORM_LABEL_NOD_ID,
    ASE_EXPORT_INTERNAL_FORM_LABEL_DOCUMENT_ID, ASE_EXPORT_INTERNAL_FORM_LABEL_REQUEST_TYPE,
    ASE_EXPORT_INTERNAL_FORM_LABEL_ROOT_CAUSE,
    ASE_EXPORT_INTERNAL_FORM_LABEL_STATUS,
    ASE_EXPORT_INTERNAL_FORM_LABEL_TO,
    ASE_EXPORT_INTERNAL_FORM_LABEL_TYPE,
    ASE_EXPORT_INTERNAL_FORM_LABEL_VEHICLE_FAMILY,
    CSV,
    ticketExportTypes
} from '../../../constants/exportConstant';
import {moduleRoles} from '../../../utils/roles';
import { uniqBy } from 'lodash';
import get from 'get-value';
import internalTicketExportMessages from '../../../intl/afterSales/internalTicketExportMessages';
import commonMessages from '../../../intl/common/commonMessages';
import rootCauseMessages from '../../../intl/afterSales/rootCauseMessages';
import formTypeMessages from '../../../intl/common/formTypeMessages';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const status = (() => {
    const arr = getInternalTicketFormStates(domains.ASE);
    arr.splice(2, 1);
    return arr;
})();

class InternalTicketExportAseForm extends Component {

    render() {
        const {handleSubmit, exportRecord, downloadExport, exportType, startDate, endDate, charSets, roles} = this.props;
        let sgOptions = [];

        if(moduleRoles.isSGEditor(roles, domains.ASE) && (get(roles, 'ASE.sgEditor.sgPermission.length') > 0)){
            const sgEditorOptions = (get(roles, 'ASE.sgEditor.sgPermission') || []).map(sg => ({
                uuid: sg.id,
                presetName: sg.name
            }))
            sgOptions = sgOptions.concat(sgEditorOptions);
        }
        if(moduleRoles.isSGAdmin(roles, domains.ASE) && (get(roles, 'ASE.sgAdmin.sgPermission.length') > 0)){
            const sgAdminOptions = (get(roles, 'ASE.sgAdmin.sgPermission') || []).map(sg => ({
                uuid: sg.id,
                presetName: sg.name
            }))
            sgOptions = sgOptions.concat(sgAdminOptions);
        }


        return (
            <StyledDiv className="border border-secondary p-4 bg-white">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <Field component={DatePickerComponent}
                                       selectsStart
                                       label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_FROM]}
                                       name={ASE_EXPORT_INTERNAL_FORM_FIELD_FROM}
                                       startDate={startDate}
                                       endDate={endDate}
                                       parse={(e) => e ? moment(e).format('YYYY-MM-DD') : null}/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <Field component={DatePickerComponent}
                                       selectsEnd
                                       label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_TO]}
                                       name={ASE_EXPORT_INTERNAL_FORM_FIELD_TO}
                                       startDate={startDate}
                                       endDate={endDate}
                                       parse={(e) => e ? moment(e).format('YYYY-MM-DD') : null}/>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_STATUS]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_STATUS}
                                                                options={status}
                                                                intlMessages={statusMessages}
                                                                isSmall/>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_IS_ASSIGNED_TO]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_IS_ASSIGNED_TO}
                                                                customOptionsMsg={uniqBy(sgOptions, (e => (e.uuid)))}
                                                                isSmall/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_HAS_BEEN_ASSIGNED_TO]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_HAS_BEEN_ASSIGNED_TO}
                                                                customOptionsMsg={uniqBy(sgOptions, (e => (e.uuid)))}
                                                                isSmall/>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_REQUEST_TYPE]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_REQUEST_TYPE}
                                                                options={[ASE_INTERNAL_TICKET_FORM]}
                                                                intlMessages={formTypeMessages}
                                />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_VEHICLE_FAMILY]}
                                                          field={ASE_EXPORT_INTERNAL_FORM_FIELD_VEHICLE_FAMILY}
                                                          isSmall
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_ENGINE_TYPE]}
                                                          field={ASE_EXPORT_INTERNAL_FORM_FIELD_ENGINE_TYPE}
                                                          maxLength={3}
                                                          isSmall
                                />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_GEARBOX_TYPE]}
                                                          field={ASE_EXPORT_INTERNAL_FORM_FIELD_GEARBOX_TYPE}
                                                          maxLength={3}
                                                          isSmall
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_NOD_ID]}
                                                          field={ASE_EXPORT_INTERNAL_FORM_FIELD_NOD_ID}
                                                          isSmall
                                />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_DOCUMENT_ID]}
                                                          field={ASE_EXPORT_INTERNAL_FORM_FIELD_DOCUMENT_ID}
                                                          isSmall
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_ROOT_CAUSE]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_ROOT_CAUSE}
                                                                options={rootCauses}
                                                                intlMessages={rootCauseMessages}
                                                                isSmall/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_DOCUMENTATION_UPDATE_NEEDED]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_DOCUMENTATION_UPDATE_NEEDED}
                                                                options={['YES', 'NO']}
                                                                intlMessages={commonMessages}
                                                                isSmall/>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-xl-6 col-lg-6 col-md-6 pb-2">
                                <RadioFields
                                    label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_TYPE]}
                                    field={ASE_EXPORT_INTERNAL_FORM_FIELD_TYPE}
                                    options={ticketExportTypes}
                                    intlMessages={internalTicketExportMessages}/>
                                <InputSelectFieldWithValidation label={internalTicketExportMessages[ASE_EXPORT_INTERNAL_FORM_LABEL_CHARSET]}
                                                                field={ASE_EXPORT_INTERNAL_FORM_FIELD_CHARSET}
                                                                options={charSets}
                                                                intlMessages={charsetMessages}
                                                                isDisabled={!exportType}
                                                                noEmpty
                                                                isSmall/>
                            </div>
                        </div>
                        <form className="form-group">
                            {(Object.keys(exportRecord).length > 0) &&
                            <div className="">
                                <div>
                                    <span className="font-weight-bold">
                                        <FormattedMessage {...internalTicketExportMessages.LAST_EXPORT}/>{' '}
                                    </span>
                                    <FormattedDate value={new Date(exportRecord.created)}/> <FormattedTime
                                    value={new Date(exportRecord.created)}/>
                                </div>
                                <div>
                                    <span className="font-weight-bold">
                                        <FormattedMessage {...internalTicketExportMessages.EXPORT_STATUS}/>{' '}
                                    </span>
                                    <FormattedMessage {...exportConstantMessages[exportRecord.status]}/>
                                </div>
                                {exportRecord.status === 'FINISH' &&
                                <PrimaryButton type="button"
                                               className="btn mr-2 float-left"
                                               onClick={downloadExport}>
                                    <FormattedMessage {...buttonMessages[BUTTON_LABEL_DOWNLOAD]}/>
                                </PrimaryButton>
                                }
                            </div>
                            }
                            <PrimaryButton type="button"
                                           className="btn mr-2 float-right"
                                           onClick={handleSubmit}>
                                <FormattedMessage {...buttonMessages[BUTTON_LABEL_EXPORT]}/>
                            </PrimaryButton>
                        </form>
                    </div>
                </div>
            </StyledDiv>
        );
    }
}

InternalTicketExportAseForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    exportType: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    charSets: PropTypes.array.isRequired,
};

const selector = (form, ...other) => (formValueSelector(form))(...other);

const mapStateToProps = (state, initialProps) => ({
    startDate: selector(initialProps.form, state, ASE_EXPORT_INTERNAL_FORM_FIELD_FROM),
    endDate: selector(initialProps.form, state, ASE_EXPORT_INTERNAL_FORM_FIELD_TO),
    exportType: (selector(initialProps.form, state, ASE_EXPORT_INTERNAL_FORM_FIELD_TYPE) === CSV),
    exportRecord: state.aseExportInternalTickets.exportRecord,
    charSets: state.profile.userDetail.charSets,
    roles: state.profile.userDetail.roles,
});

export default reduxForm({
    enableReinitialize: true,
})(injectIntl(connect(mapStateToProps, {})(InternalTicketExportAseForm)));
